var _rect, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextgen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    role: "img",
    "aria-label": "NextGen Healthcare",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 238,
    height: 58,
    rx: 10,
    fill: "none",
    stroke: "#cbd5e1",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 42 L14 18 L38 42 L38 18",
    fill: "none",
    stroke: "#1f6f3c",
    strokeWidth: 3,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 30,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1f6f3c"
  }, "NextGen")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 46,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 500,
    fill: "#64748b",
    letterSpacing: 1.2
  }, "HEALTHCARE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextgen);
export default __webpack_public_path__ + "static/media/nextgen.b6a699317b25f933407c4d74b926e0da.svg";
export { ForwardRef as ReactComponent };